import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';

@Directive({
  selector: 'input[appNoSpaceInputAllowCopyPaste]'
})
export class NoSpaceAllowCopyPasteInputDirective {

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  // @HostListener('input', ['$event']) onInputChange(event: any) {
  //   const initialValue = this.el.nativeElement.value;
  //   const sanitizedValue = initialValue.replace(/[^0-9+]/g, ''); // Remove non-numeric characters
  //   if (initialValue !== sanitizedValue) {
  //     this.renderer.setProperty(this.el.nativeElement, 'value', sanitizedValue);
  //     event.stopPropagation();
  //   }
  // }

  
  // @HostListener('input', ['$event']) onInputChange(event: any) {
  //   const initialValue = this.el.nativeElement.value;
  //   const sanitizedValue = initialValue.replace(/[^a-zA-Z0-9@]/g, ''); // Only letters and numbers
  //   if (initialValue !== sanitizedValue) {
  //     this.renderer.setProperty(this.el.nativeElement, 'value', sanitizedValue);
  //     event.stopPropagation();
  //   }
  // }
  //! *********** Old start
  // @HostListener('input', ['$event']) 
  // onInputChange(event: any) {
  //   const initialValue = this.el.nativeElement.value;
  //   const sanitizedValue = initialValue.replace(/[^a-zA-Z0-9@]/g, ''); // Allow letters, numbers, and @
  //   if (initialValue !== sanitizedValue) {
  //     this.renderer.setProperty(this.el.nativeElement, 'value', sanitizedValue);
  //     event.stopPropagation();
  //   }
  // }
  //! *********** old end
  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    const allowedKeys = [
      'Backspace',
      'Tab',
      'ArrowLeft',
      'ArrowRight',
      'Delete',
      ' '
    ];

    const isLetter = /^[a-zA-Z0-9@]$/.test(event.key);
    const isAllowed = allowedKeys.includes(event.key);

    if (!isLetter && !isAllowed) {
      event.preventDefault();
    }
  }

  // Clean pasted or typed input
  @HostListener('input', ['$event']) 
  onInputChange(event: any) {
    const initialValue = this.el.nativeElement.value;

    // Allow only letters and spaces
    let sanitizedValue = initialValue.replace(/[^a-zA-Z0-9@ ]/g, '');

    // Replace multiple spaces with a single space, and trim
    sanitizedValue = sanitizedValue.replace(/\s+/g, ' ').trimStart();

    if (initialValue !== sanitizedValue) {
      this.renderer.setProperty(this.el.nativeElement, 'value', sanitizedValue);
      event.stopPropagation();
    }
  }

  // Optional: Prevent paste of invalid content
  @HostListener('paste', ['$event'])
  blockPaste(event: ClipboardEvent) {
    const pasted = event.clipboardData?.getData('text') ?? '';
    if (!/^[a-zA-Z0-9@ ]+$/.test(pasted)) {
      event.preventDefault();
    }
  }


  // @HostListener('paste', ['$event']) blockPaste(event: ClipboardEvent) {
  //   event.preventDefault();
  // }

  // @HostListener('copy', ['$event']) blockCopy(event: ClipboardEvent) {
  //   event.preventDefault();
  // }

  // @HostListener('cut', ['$event']) blockCut(event: ClipboardEvent) {
  //   event.preventDefault();
  // }

}
